import { useProjectContext } from '@/context';
import { Tooltip } from 'primereact/tooltip';
import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

const MainLogo = (): ReactElement => {
  const { selectedProjectName } = useProjectContext();

  return (
    <div className='mb-10'>
      <Tooltip target='.main-logo-tooltip' />
      <NavLink
        to='/'
        className='text-3xl cursor-pointer main-logo-tooltip'
        data-pr-tooltip={selectedProjectName ?? undefined}
      >
        <img src='/assets/data2logo.png' alt='Logo' className='w-10 h-10' />
      </NavLink>
    </div>
  );
};

export default MainLogo;
